import { useQuery } from "react-query";
import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";

const fetchStatistics = async (token, days) => {
  const response = await fetch(
    `${process.env.REACT_APP_SERVER_URL}/order/statistics?days=${days}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.message || `Statistics request failed (${response.status})`);
  }

  return response.json();
};

const useStatistics = (days = 30) => {
  const { token, isLoggedIn } = useContext(AuthContext);

  return useQuery(
    ["adminStatistics", token, days],
    () => fetchStatistics(token, days),
    {
      enabled: !!token && isLoggedIn,
      retry: 1,
      staleTime: 60 * 1000,
    }
  );
};

export default useStatistics;
